import api from "../../../api/api";

export const patchEnquiries = data => api.patch("enquiries", data);
